import { server } from '../engine/server'
import { modal } from '../utilities/modal'

var UserBilling = Class.create({
  	initialize: function() {
	},
	reactivateSubscription: function(callback) {
		var self = this;
		modal.showDangerModalWithOK("Are you sure?","You are about to re-activate your subscription.","Yes, Activate!");
		jQuery(".move-on").on('click',function() {
			var url = "user/stripe/activate";
			var params = data;
			// #  Send to server object for processing
			var data = server.getData(url,params,false, "PUT");
			// #  Listen to our data
			data
			.done(function(response){
				if(response.status === 'ERROR') {
					modal.showInfo('Error! ' + JSON.parse(response.message.httpBody).error.message, 'danger', 'top', 'center');
				} else if(response.status == 'ERROR_INTERNAL') {
					modal.showInfo('Error! ' + response.message[0], 'danger', 'top', 'center');
				}else {
					callback(response);
				}
			})
			.fail(function(e){
				modal.showInfo("Oops! Something went wrong.", "danger", "top", "center");
			});
		});
	},
	cancelSubscription: function(callback) {
		var self = this;
		modal.showDangerModalWithOK("Are you sure?","You are about to cancel your subscription.  You can re-activate at anytime.","Yes, Cancel");
		jQuery(".move-on").on('click',function() {
			var url = "user/stripe/cancel";
			var params = data;
			// #  Send to server object for processing
			var data = server.getData(url,params,false, "PUT");
			// #  Listen to our data
			data
			.done(function(response){
				if(response.status === 'ERROR') {
					modal.showInfo('Error! ' + JSON.parse(response.message.httpBody).error.message, 'danger', 'top', 'center');
				} else if(response.status == 'ERROR_INTERNAL') {
					modal.showInfo('Error! ' + response.message[0], 'danger', 'top', 'center');
				}else {
					callback(response);
				}
			})
			.fail(function(e){
				modal.showInfo("Oops! Something went wrong.", "danger", "top", "center");
			});
		});
	},
	getHistory: function(callback) {
		var url = "user/billing/history";
		var data = server.getData(url, null, false, "GET");
		data
		.done(function(response){
			if(response.status === 'ERROR') {
				modal.showInfo('Error! ' + JSON.parse(response.message.httpBody).error.message, 'danger', 'top', 'center');
			} else if(response.status == 'ERROR_INTERNAL') {
				modal.showInfo('Error! ' + response.message[0], 'danger', 'top', 'center');
			}else {
                if(callback) {
                    callback(response);
                }
			}
		})
		.fail(function(e){
			modal.showInfo("Oops! Looks like you are missing data.", "warning", "top", "center");
		});
	},
	getBillingInformation: function(callback) {
		var url = "user/stripe/account";
		var params = data;
		// #  Send to server object for processing
		var data = server.getData(url,params,false);
		// #  Listen to our data
		data
		.done(function(response){
			if(response.status === 'ERROR') {
				modal.showInfo('Error! ' + JSON.parse(response.message.httpBody).error.message, 'danger', 'top', 'center');
			} else if(response.status == 'ERROR_INTERNAL') {
				modal.showInfo('Error! ' + response.message[0], 'danger', 'top', 'center');
			}else {
				callback(response);
			}
		})
		.fail(function(e){
			modal.showInfo("Oops! Something went wrong.", "danger", "top", "center");
		});
	},
	getMerchantAccount: function(callback) {
		var url = "user/billing/merchant";
		var params = data;
		// #  Send to server object for processing
		var data = server.getData(url,params,false);
		// #  Listen to our data
		data
		.done(function(response){
			if(response.status === 'ERROR') {
				modal.showInfo('Error! ' + JSON.parse(response.message.httpBody).error.message, 'danger', 'top', 'center');
			} else if(response.status == 'ERROR_INTERNAL') {
				modal.showInfo('Error! ' + response.message[0], 'danger', 'top', 'center');
			}else {
				callback(response);
			}
		})
		.fail(function(e){
			modal.showInfo("Oops! Something went wrong.", "danger", "top", "center");
		});
    },
    saveBillingInformation: function(data, callback) {
		// prepare our data to be sent
		var url = "user/stripe/createaccount";
		var params = data;
		// #  Send to server object for processing
		var data = server.getData(url,params,false, "POST");
		// #  Listen to our data
		data
		.done(function(response){
			if(response.status === 'ERROR') {
				modal.showInfo('Error! ' + JSON.parse(response.message.httpBody).error.message, 'danger', 'top', 'center');
			} else if(response.status == 'ERROR_INTERNAL') {
				modal.showInfo('Error! ' + response.message[0], 'danger', 'top', 'center');
			}else {
				callback(response);
			}
		})
		.fail(function(e){
			modal.showInfo("Oops! Looks like you are missing data.", "warning", "top", "center");
		});
	},
	saveAccountReceivable: function(accountData, callback) {
		modal.showDangerModalWithOK("Create Payment Account?","Is the information entered correct?","Get Started!");
		jQuery(".move-on").on('click',function() {
			// prepare our data to be sent
			var url = "user/stripe/accountreceivable";
			var params = accountData;
			// #  Send to server object for processing
			var data = server.getData(url,params, true, "POST");
			// #  Listen to our data
			data
			.done(function(response){
				if(response.status === 'ERROR') {
					modal.showInfo('Error! ' + JSON.parse(response.message.httpBody).error.message, 'danger', 'top', 'center');
				} else if(response.status == 'ERROR_INTERNAL') {
					modal.showInfo('Error! ' + response.message[0], 'danger', 'top', 'center');
				}else {
					callback(response);
				}
			})
			.fail(function(e){
				modal.showInfo("Oops! Looks like you are missing data.", "warning", "top", "center");
			});
		});
	}
});

export let userBilling = new UserBilling();


// WEBPACK FOOTER //
// app/core/controllers/UserBilling.js